import { useEffect } from 'react'

import { each } from 'lodash'

import api from 'common/api'
import { FIELDS } from 'common/metadata-constants'
import { EVENT_CLICK_SOURCES } from 'common/track-event-constants'
import { useIsAuthed } from 'components/AuthShield'

import { SCID_MATCH, TAG } from '../../constants'
import { IResultComponentProps as collegesIResultComponentProps } from '../../use-search-configurations/search-colleges/ResultComponent'
import { getTo as getPostsTo } from '../../use-search-configurations/search-posts/ResultComponent'

const HISTORICAL_SEARCH_URL = '/api/historical_search'

interface IHistoricalResults {
  History: {
    Label: string
    Scid: number
    City: string
    State: string
    Type: string
  }[]
}

interface IUseRecentSearches {
  open: boolean
  historicalResults: any[]
  setHistoricalResults: (historicalResults: any[]) => void
}

interface tagIResultComponentProps {
  type: string
  to: string
  label: string
  hoverText: string
}

type TnewHistoricalResults = (collegesIResultComponentProps | tagIResultComponentProps)[]

export const useRecentSearches = ({ open, historicalResults, setHistoricalResults }: IUseRecentSearches) => {
  const isAuthed = useIsAuthed()

  useEffect(() => {
    if (isAuthed && open) {
      api.get(HISTORICAL_SEARCH_URL).then((results) => {
        const newHistoricalResults: TnewHistoricalResults = []
        each((results as IHistoricalResults).History, (result, locationIndex) => {
          switch (result.Type) {
            case SCID_MATCH:
              newHistoricalResults.push({
                type: result.Type,
                scid: result.Scid,
                name: result.Label,
                city: result.City,
                state: result.State,
                linkParams: { source: EVENT_CLICK_SOURCES.TYPE_AHEAD_SEARCH },
                listItemProps: {
                  button: true,
                  disableGutters: false,
                  style: {
                    padding: '8px 16px',
                  },
                },
                additionalMetadata: { [FIELDS.LOCATION_INDEX]: locationIndex },
              })
              break

            case TAG: {
              const tag = result.Label
              newHistoricalResults.push({
                type: result.Type,
                to: `${getPostsTo(tag)}&source=${EVENT_CLICK_SOURCES.TYPE_AHEAD_SEARCH}`,
                label: tag,
                hoverText: `Visit posts for tag ${tag}`,
              })
              break
            }
            default:
              break
          }
        })
        setHistoricalResults(newHistoricalResults)
      })
    }
  }, [open, isAuthed, setHistoricalResults])

  return historicalResults.slice(0, 3)
}
